import { Link, useLocation } from 'react-router-dom';
import { useSeo } from '@/hooks/useSeo';

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: 'ไม่พบหน้าที่คุณต้องการ | Forex Academy Thailand',
    description: 'ไม่พบหน้าที่คุณต้องการ กลับไปเริ่มเรียนรู้ Forex จากหน้าแรกของเรา',
    canonicalPath: location.pathname,
    noindex: true,
  });

  return (
    <div className="bg-background-50">
      <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-4 py-24 text-center md:py-32">
        <span className="font-num text-6xl font-semibold text-primary-200 md:text-8xl">404</span>
        <h1 className="mt-6 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">ไม่พบหน้าที่คุณต้องการ</h1>
        <p className="mt-3 font-num text-sm text-foreground-500">{location.pathname}</p>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
          หน้านี้อาจถูกย้ายหรือไม่มีอยู่แล้ว กลับไปเริ่มเรียนรู้ Forex จากหน้าแรกได้เลย
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line text-base" />
            กลับหน้าแรก
          </Link>
          <Link
            to="/forex-basics"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-book-open-line text-base" />
            เรียน Forex พื้นฐาน
          </Link>
        </div>
      </div>
    </div>
  );
}